var $ = require("jquery");


$(function(){

  function imgPreload(imgPath) {
    $('<img>').attr('src', imgPath);
  }
  $('.js-pic__trigger li img').each(function(){
    var imgPath = $(this).attr('src').replace('s.jpg','f.jpg');
    imgPreload(imgPath);
  });


  $('.js-pic__trigger li img').each(function(index,elem) {
    var cap = $(this).attr('data-cap');
    if(index === 0) {
      $('.js-pic__cap').html(cap);
      return false;
    }
  });

  var $trigger = $('.js-pic__trigger img');
  var capImg = $('.js-pic__trigger li img');
  var $images = $('.info__wrap--img, .info__wrapImgDisplay');

  // 画像data属性取得
  var $picCap = $('.js-pic__cap');
  var $picPart = $('.js-pic__part');
  var $picUrl = $('.js-pic__part a');

  //　初期表示

  var $sImg = $('.js-pic__trigger li:first-child img');
  $('.js-pic__view img').attr('src', '');
  if($sImg.length) {
    var initImgCap = $sImg.attr('data-cap');
    var initImgPart = $sImg.attr('data-part');
    var initImgUrl = $sImg.attr('data-url');
    var imgPath = $sImg.attr('src')
    var imgPathFull = imgPath.replace('s.jpg', 'f.jpg');
    $('.js-pic__view img').attr('src', imgPathFull);
    if(initImgCap === "" ) {
     $picCap.html("");
    } else {
     $picCap.html(initImgCap);
    }
    if(initImgPart === "" ) {
      $picPart.html("");
    } else {
      $picPart.html('<a href="'+ initImgUrl +'" class="js-pic__url">'+ initImgPart +' <i class="fa fa-arrow-circle-right"></i></a>');
    }
    setTimeout(function(){
      $('.info__wrapImg').addClass('is-View');
    }, 500);
  }

  // サムネイルクリックアクション設定
  var flag = true;
  $trigger.on('click', function(){
    var cap = $(this).attr('data-cap');
    var part = $(this).attr('data-part');
    var url = $(this).attr('data-url');

    $('.js-pic__trigger li img').each(function(){
      var imgPath = $(this).attr('src').replace('s.jpg','f.jpg');
      imgPreload(imgPath);
    });

    if(flag) {
      flag = false;
      // サムネイルのacを削除
      $('.js-pic__trigger li').removeClass('ac');

      // クリックしたサムネイルにacを追加
      $(this).parent().addClass('ac');

      // 画像パス取得して、パスを書き換える
      var full = $(this).attr('src').replace('s.jpg','f.jpg');


      $('.js-pic__view img').attr('src', full);
      if(cap === "" ) {
       $picCap.html("");
      } else {
       $picCap.html(cap);
      }
      if(part === "" ) {
        $picPart.html("");
      } else {
        $picPart.html('<a href="'+ url +'" class="js-pic__url">'+ part +' <i class="fa fa-arrow-circle-right"></i></a>');
      }

      flag = true;
    } else {
      return;
    }

  });

});